import React, { Component } from 'react';
import LoginAnnouncementModal from '../in-modal/login-announcement/main';
import { Common } from '../../core/common';
import { Log } from 'ng2-logger';
import { Modal } from 'reactstrap';

interface IBaseModalProps {
    headerState: any;
    headerIcon?: string;
    modalIsOpen?: boolean;
    onClose?: (refresh: boolean) => void;
    minWidth?: any;
    minHeight?: any;
    backdrop?: string;
    modalFooter?: any;
    showHeader?: boolean;
    modalBodyClassName?: string;
    modalHeaderClassName?: string;
    modalContentClassName?: string;
}

const _logger = Log.create('login.tsx');
let _common: Common;
class BaseModal extends Component<IBaseModalProps> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    setClose = (refresh: boolean = false) => {
        if (this.props.onClose) {
            this.props.onClose(refresh);
        }
    };

    setCloseModal = () => {
        this.setClose();
    };

    public render() {

        let headerStateText: any;
        if (typeof(this.props.headerState) == 'string')
        {
            headerStateText = <p className="mb-0" dangerouslySetInnerHTML={{ __html: this.props.headerState }} />;
        }
        else
        {
            headerStateText = this.props.headerState;
        }

        return (
            <Modal
                contentClassName={this.props.modalContentClassName}
                backdrop={this.props.backdrop === 'static' ? 'static' : true}
                className="question-modal exam-modal-stats"
                style={{ minWidth: this.props.minWidth ? this.props.minWidth : null, minHeight: this.props.minHeight ? this.props.minHeight : null }}
                isOpen={this.props.modalIsOpen}
                toggle={this.setCloseModal}>
                <div className={this.props.modalHeaderClassName ? this.props.modalHeaderClassName : 'border-0 d-flex justify-content-between p-0'} style={{ marginBottom: 0 }}>
                    {this.props.showHeader && (
                        <h5 className="modal-title d-inline-flex align-items-center pt-0" id="exampleModalLabel" style={{ marginBottom: 10, justifyContent: (!_common.isArabic(this.props.headerState,  document.body.getAttribute('dir'))) ?'space-between': 'unset', width: '100%' }}>
                            {this.props.headerIcon && (
                                <img className="mr-4" style={{ width: 40 }} src={_common.GetActivityIcons(this.props.headerIcon)} alt="icon" />
                            )}
                            {headerStateText} 
                        </h5>
                    )}
                        <button type="button" className="close" onClick={this.setCloseModal} aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                </div>
                <div className={this.props.modalBodyClassName ? this.props.modalBodyClassName : 'modal-body pt-0'}>
                    {this.props.children}
                </div>
                {this.props.modalFooter ? (this.props.modalFooter()) : ''}
            </Modal>
        );
    }
}

export default BaseModal;
